export default {
  // tab
  dbs_subtitle_overview: 'Overview',
  dbs_subtitle_mktcost: 'MKT Cost',
  dbs_subtitle_publishing_headcount: 'Publishing Business Headcount', // same as dbs_publishing_headcount
  dbs_subtitle_publishing_project: 'Publishing Project',
  // 1.0 Overview tab
  dbs_button_decision_point_list: 'Decision Points List',
  dbs_total_revenue_publishing: 'Total Gross Revenue_Publishing',
  bs_total_revenues: 'Gross Revenue',
  dbs_total_profit_publishing: 'Total Profit_Publishing',
  dbs_project: 'Project',
  dbs_table_mature: 'Mature',
  dbs_table_longtail: 'Long-Tail',
  dbs_table_newly_online: 'Newly Online',
  dbs_table_incubation: 'Incubation',
  dbs_table_urgency: 'Urgency',
  dbs_table_issue: 'Issue',
  dbs_table_expected_time: 'Expected Time',
  dbs_table_bos_recommendation: `BOS' Recommendation`,
  dbs_appendix_notes: 'Appendix & Notes',
  // 2.0 MKT Cost tab
  dbs_mkt_total_revenue_publishing_studio: 'Total MKT Cost_Publishing & Studio Management',
  dbs_table_publishing_hq: 'Publishing - HQ',
  dbs_table_studio_hq: 'Studio - HQ',
  dbs_table_central_others: 'Central & Others',
  dbs_table_sustainability: 'Sustainability',
  dbs_mkt_cost_by_projects: 'MKT Cost by Projects',
  dbs_mkt_budget_application_calendar : 'MKT Budget Application Calendar',
  // 3.0 Publishing Headcount tab
  dbs_publishing_headcount: 'Publishing Business Headcount', // same as dbs_subtitle_publishing_headcount
  dbs_projects_headcount: 'Headcount Trend',
  dbs_projects_headcount_table: 'Project Headcount',
  dbs_publishing_hc: 'Publishing',
  dbs_capability_box: 'Capability Box',
  dbs_full_year_kpi_avg: 'Full Year KPI Avg.',
  dbs_y2_live_ops: 'Y2 Live Ops',
  dbs_y1_include_6_months_pre_launch: 'Y1 (Include 6 months pre launch)',
  dbs_production: 'Production',
  dbs_pre_production: 'Pre-Production',
  dbs_canceled: 'Canceled',
  dbs_publishing_business_subtotal: 'Publishing Business Subtotal',
  dbs_capability_box_subtotal: 'Capability Box Subtotal',
  dbs_studios_subtotal: 'Studios Subtotal',
  // 4.0 Publishing Project tab
  dbs_revenue: 'Revenue',
  dbs_revenues: 'Gross Revenue',
  dbs_net_revenue: 'Net Revenue',
  dbs_headcount: 'Headcount',
  dbs_tech_and_other_cost: 'Tech and Other Cost',
  dbs_key_metrics: 'Key Metrics',
  dbs_more_available_at_dashboad: 'More metrics available at Dashboard',
  dbs_publishing_review_updates: 'Publishing Review Updates',
  dbs_field_empty_warning: 'field(s) cannot be empty, please fill in',
  dbs_cannot_delete_category_with_projects: 'Cannot delete phase while it still contains studios',
  dbs_cannot_delete_category_while_contains_projects: 'Cannot delete category while it still contains projects',
  dbs_add_category: 'Add Category',
  dbs_finance_data_notice: 'Financial data will be automatically calculated and updated after saving',
  dbs_25A_25F_25B_data_notice: '25A, 25F, 25B data will be automatically calculated and updated after saving',
  dbs_delete_category_confirm: 'Are you sure you want to delete this category?',
  dbs_headcount_metrics_data_notice: 'Some metrics are sourced from the database and not editable. If any updates are required, please reach out to judymao',
  // LineChart: 'Line Chart',
  // BarChart: 'Bar Chart',
};
